module.exports = __webpack_public_path__ + "static/Yuan_ti-d7d6593a24ad6ae14a1edeea7600d0af.jpg";